module.exports = __webpack_public_path__ + "static/media/a-1.9f961265.jpg";